<script setup>
import BreezeButton from '@/Components/Button.vue';
import BreezeGuestLayout from '@/Layouts/Guest.vue';
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Head, useForm } from '@inertiajs/inertia-vue3';

const props = defineProps({
  email: String,
  token: String,
});

const form = useForm({
  token: props.token,
  email: props.email,
  password: '',
  password_confirmation: '',
});

const submit = () => {
  form.post(route('password.update'), {
    onFinish: () => form.reset('password', 'password_confirmation'),
  });
};
</script>

<template>
  <Head title="パスワードをリセットする" />

  <BreezeGuestLayout>
    <section class="main login">

      <h2 class="login_title c-heading-h2">パスワードをリセットする</h2>

      <BreezeValidationErrors class="mb-4" />

      <form @submit.prevent="submit">
        <div class="c-input_row">
          <BreezeLabel for="email" value="メールアドレス" />
          <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
        </div>

        <div class="c-input_row">
          <BreezeLabel for="password" value="パスワード" />
          <BreezeInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
        </div>

        <div class="c-input_row">
          <BreezeLabel for="password_confirmation" value="パスワード（確認）" />
          <BreezeInput id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
        </div>

        <div class="flex items-center justify-end mt-4">
          <BreezeButton :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="c-button">
            パスワードをリセットする
          </BreezeButton>
        </div>
      </form>
    </section>
  </BreezeGuestLayout>
</template>
